var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"consignment-popover"},[_c('ConsignmentPeek',{attrs:{"consignment":_vm.consignment,"show-cards":['information', 'items', 'tracking']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }